export default __webpack_public_path__ + "static/media/staring-logo.16ca13ca.svg";